import {IdName} from '@core/src/public-api';
import {Recommendation} from './recommendation.model';
import {RequestGuarantorType} from './request.model';

export interface Appointment {
  id?: number;
  startDate?: number;
  endDate?: number;
  serviceId?: number;
  serviceName?: string;
  centerId?: number;
  centerName?: string;
  centerAddress?: string;
  centerLatitude?: number;
  centerLongitude?: number;
  centerPhone?: string;
  centerFax?: string;
  professionalId?: number;
  professionalName?: string;
  reasonId?: number;
  reasonName?: string;
  modality?: string;
  stateId?: number;
  stateName?: string;
  stateCode?: string;
  teleconsultation?: boolean;
  url?: string;
  actions?: string[];
  informedConsents?: IdName[];
  benefits?: IdName[];
  recommendations?: Recommendation[];
  requestGuarantorType?: RequestGuarantorType;
  arrivalStartDate?: number;
  arrivalEndDate?: number;
  ticketSequence?: string;
  locationName?: string;
  requiresSEOGA?: boolean;
  requiresSEOGAAuth?: boolean;
  cardNumberSEOGA?: string;
  allowExternalAdmissionAttention?: boolean;
  showWaitingRoom?: boolean;
  allowAppointmentConfirmation?: boolean;
  appoConfirmed?: boolean;
  patientId?: number;
  allowReschedule?: boolean;
  myTurn?: boolean;
}

export class AppointmentListFilters {
  startDate?: number;
  endDate?: number;
  centerId?: number;
  serviceId?: number;
  pending?: boolean;
  sort?: string;
  isWaitingRoom?: boolean;
}

export class AppointmentTurn {
  startDate?: string;
  serviceName?: string;
  centerName?: string;
  professionalName?: string;
  reasonName?: string;
  teleconsultation?: string;
  ticketSequence?: string;
  locationName?: string;
  topic?: string;
}

export class AppointmentArrival {
  insuranceIdentificationType?: string;
  insuranceIdentificationCode?: string;
  authorizationCode?: string;
  voucherIdentificationType?: string;
  voucherId?: string;
}

export class AppointmentNotice {
  id: string;
  target: IdName;
  category: IdName;
  type: IdName;
  description: string;
}
